"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyRun = exports.lazyGet = exports.lazyInject = exports.di = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var inversify_inject_decorators_1 = tslib_1.__importDefault(require("inversify-inject-decorators"));
var di = new inversify_1.Container();
exports.di = di;
var lazyInject = (0, inversify_inject_decorators_1.default)(di).lazyInject;
exports.lazyInject = lazyInject;
var lazyGet = function (id) {
    return id && di.isBound(id) ? di.get(id) : undefined;
};
exports.lazyGet = lazyGet;
var lazyRun = function (id, params) { var _a; return (_a = lazyGet(id)) === null || _a === void 0 ? void 0 : _a.run(params); };
exports.lazyRun = lazyRun;
//# sourceMappingURL=di.js.map